import { appEnv } from "@/constants/app-env";
import type { User } from "@/hooks/auth/use-user";
import * as Sentry from "@sentry/react";

export function captureError(error: Error | unknown) {
  console.error(error);
  if (appEnv.isDevelopment) {
    return;
  }

  Sentry.captureException(error);
}

export function setupUserContext(user: User) {
  if (appEnv.isDevelopment) {
    return;
  }

  Sentry.setUser(user);
}
